


























































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import AccountModule from '@/store/modules/Account';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component
export default class PasswordView extends Mixins(ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  AccountInstance = getModule(AccountModule, this.$store);

  userId = this.AuthInstance.user._id;

  dataModel = {
    password: this.initialPassword(),
  }

  mainKey = 0;

  async onSubmitPassword() {
    this.dataModel.password.username = this.AuthInstance.user.username;
    const { dataModel: { password }, userId } = this;
    const res = await this.AccountInstance.ResetPassword({
      userId,
      ...password,
    });
    this.checkError(res);
    if (res.code === 0) {
      this.dataModel.password = this.initialPassword();
      this.mainKey += 1;
    }
  }

  initialPassword() {
    return {
      username: null,
      oldPassword: null,
      newPassword: null,
      confirmPassword: null,
      isProfile: true,
    };
  }
}
